/**
 * @generated SignedSource<<694d2d5caaa63c3e537c576fc199929b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "SINGLE_SELECT" | "TEXT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueFieldPickerIssueField$data = {
  readonly dataType?: IssueFieldDataType;
  readonly id?: string;
  readonly name?: string;
  readonly " $fragmentType": "IssueFieldPickerIssueField";
};
export type IssueFieldPickerIssueField$key = {
  readonly " $data"?: IssueFieldPickerIssueField$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFieldPickerIssueField">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueFieldPickerIssueField"
};

(node as any).hash = "7ea9a588ce57b5d2c9bd83588e43bdbb";

export default node;
